/* XRED · shop grid. Heat chips (client-side by data-heat rank, or a Shopify
   filter through the Section Rendering API), sort (heat client-side, the rest
   fetched), the filter panel, pagination without a reload. Also binds the
   [data-add] quick add on pages that load this file without xred-product.js.
   Re-inits on shopify:section:load. */
(function () {
  'use strict';
  var H = window.XRED || (window.XRED = { routes: {}, strings: {} });
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  if (!H.__quickAddBound) {
    H.__quickAddBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add]'); if (!btn || btn.disabled) return;
      e.preventDefault();
      var fd = new FormData();
      fd.append('id', btn.getAttribute('data-add'));
      fd.append('quantity', '1');
      btn.disabled = true;
      var p = H.addToCart ? Promise.resolve(H.addToCart(fd)) : fetch(H.routes.cartAdd || '/cart/add', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || H.strings.cartError); document.dispatchEvent(new CustomEvent('xred:cart:added', { detail: j })); return j; }); });
      p.then(function () { btn.classList.add('btn--added'); setTimeout(function () { btn.classList.remove('btn--added'); }, 1200); })
        .catch(function (err) { if (H.toast) H.toast(err && err.message || H.strings.cartError); })
        .then(function () { btn.disabled = false; });
    });
  }

  function reveal(root) {
    $$('[data-sc-in]', root).forEach(function (n) {
      n.classList.add('sc-in');
      Array.prototype.forEach.call(n.children, function (k) { k.classList.add('sc-in'); });
    });
  }
  function initWrap(wrap) {
    if (wrap.__xrFacets) return; wrap.__xrFacets = true;
    function countText(n) {
      var t = n === 1 ? (wrap.dataset.countOne || '# item') : (wrap.dataset.countOther || '# items');
      return t.replace('#', n);
    }
    var sid = wrap.dataset.sectionId;
    var mode = wrap.dataset.heatMode || 'client';
    var sortSelect = $('[data-sort-select]', wrap);
    var timer = null;
    var heatFilter = 'all';
    var heatSort = sortSelect && /^heat-/.test(sortSelect.value) ? sortSelect.value : null;

    function results() { return $('[data-results]', wrap); }
    function facetsForm() { return $('[data-facets-form]', wrap); }

    /* ---------------------------------------------- client heat filter/sort */
    function applyClient() {
      var grid = $('[data-grid]', wrap); if (!grid) return;
      var cards = $$('.mini', grid);
      var shown = cards.filter(function (c) { return heatFilter === 'all' || c.dataset.heat === heatFilter; });
      if (heatSort) {
        shown.sort(function (a, b) {
          var ha = +a.dataset.heat, hb = +b.dataset.heat, pa = +a.dataset.price, pb = +b.dataset.price;
          return heatSort === 'heat-asc' ? (ha - hb || pa - pb) : (hb - ha || pa - pb);
        });
      }
      cards.forEach(function (c) { c.hidden = shown.indexOf(c) === -1; });
      shown.forEach(function (c) { grid.appendChild(c); c.classList.add('sc-in'); });
      var count = $('[data-results-count]', wrap);
      if (count && (heatFilter !== 'all' || mode === 'client')) count.textContent = countText(heatFilter === 'all' ? cards.length : shown.length);
    }

    /* ------------------------------------------------ server (fetch section) */
    function currentParams() {
      var p = new URLSearchParams(location.search);
      var form = facetsForm();
      if (form) {
        // Rebuild filter params from the form; keep anything the form does not own.
        var owned = {};
        $$('[name]', form).forEach(function (el) { owned[el.name] = true; });
        Object.keys(owned).forEach(function (k) { p.delete(k); });
        new FormData(form).forEach(function (v, k) { if (v !== '') p.append(k, v); });
      }
      if (sortSelect && !/^heat-/.test(sortSelect.value)) p.set('sort_by', sortSelect.value);
      p.delete('page');
      return p;
    }
    function render(params, push) {
      var qs = params.toString();
      var url = location.pathname + (qs ? '?' + qs : '');
      wrap.classList.add('is-loading');
      fetch(location.pathname + '?' + (qs ? qs + '&' : '') + 'section_id=' + sid)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-collection]');
          if (!fresh) { location.href = url; return; }
          ['[data-results]', '[data-chips]', '[data-filters]', '[data-results-count]'].forEach(function (sel) {
            var a = $(sel, wrap), b = fresh.querySelector(sel);
            if (a && b) { var wasHidden = a.hidden; a.innerHTML = b.innerHTML; if (sel === '[data-filters]') a.hidden = wasHidden; }
          });
          var ac = $('[data-active-count]', wrap), fac = fresh.querySelector('[data-active-count]');
          if (ac && fac) { ac.textContent = fac.textContent; ac.hidden = fac.hidden; }
          if (push) history.pushState({ xr: true }, '', url);
          reveal(wrap);
          if (H.init) H.init(wrap);
          applyClient();
          document.dispatchEvent(new CustomEvent('xred:collection:updated', { detail: { root: wrap } }));
        })
        .catch(function () { location.href = url; })
        .then(function () { wrap.classList.remove('is-loading'); });
    }

    /* ------------------------------------------------------------ events */
    wrap.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-chips] .chip');
      if (chip && chip.hasAttribute('data-filter')) {
        $$('[data-chips] [data-filter]', wrap).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        heatFilter = chip.dataset.filter;
        applyClient();
        return;
      }
      if (chip && chip.hasAttribute('data-facet-name')) {
        var p = currentParams();
        var on = chip.getAttribute('aria-pressed') === 'true';
        p.delete(chip.dataset.facetName);
        if (!on) p.append(chip.dataset.facetName, chip.dataset.facetValue);
        render(p, true);
        return;
      }
      if (chip && chip.hasAttribute('data-facet-clear')) {
        var pc = currentParams(); pc.delete(chip.dataset.facetClear); render(pc, true); return;
      }
      var toggle = e.target.closest('[data-filter-toggle]');
      if (toggle) { setPanel($('[data-filters]', wrap).hidden); return; }
      if (e.target.closest('[data-filter-close]')) { setPanel(false); return; }
      var rm = e.target.closest('[data-facet-remove]');
      if (rm) {
        e.preventDefault();
        var u = new URL(rm.href, location.origin);
        var pr = u.searchParams;
        if (sortSelect && !/^heat-/.test(sortSelect.value) && !pr.has('sort_by')) pr.set('sort_by', sortSelect.value);
        render(pr, true);
        return;
      }
      var page = e.target.closest('[data-pagination] a');
      if (page) {
        e.preventDefault();
        var pu = new URL(page.href, location.origin);
        render(pu.searchParams, true);
        var top = wrap.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
    wrap.addEventListener('input', function (e) {
      if (!e.target.closest('[data-facets-form]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () { render(currentParams(), true); }, e.target.type === 'number' ? 600 : 80);
    });
    wrap.addEventListener('submit', function (e) {
      if (!e.target.matches('[data-facets-form]')) return;
      e.preventDefault(); render(currentParams(), true);
    });
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        if (/^heat-/.test(sortSelect.value)) { heatSort = sortSelect.value; applyClient(); return; }
        heatSort = null;
        var hidden = facetsForm() && $('[data-sort-hidden]', facetsForm());
        if (hidden) hidden.value = sortSelect.value;
        render(currentParams(), true);
      });
    }
    window.addEventListener('popstate', function () { render(new URLSearchParams(location.search), false); });
    wrap.addEventListener('keydown', function (e) {
      var panel = $('[data-filters]', wrap);
      if (e.key === 'Escape' && panel && !panel.hidden) { setPanel(false); var t = $('[data-filter-toggle]', wrap); if (t) t.focus(); }
    });

    function setPanel(open) {
      var panel = $('[data-filters]', wrap); if (!panel) return;
      panel.hidden = !open;
      var t = $('[data-filter-toggle]', wrap);
      if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var f = panel.querySelector('input, button'); if (f) f.focus({ preventScroll: true }); }
    }

    // First paint: catalog order and the stagger reveal. A heat sort picked
    // before a reload (browser restored the select) applies right away.
    var count = $('[data-results-count]', wrap);
    if (count && mode === 'client' && $('[data-grid]', wrap)) count.textContent = countText($$('.mini', $('[data-grid]', wrap)).length);
    if (heatSort) applyClient();
  }

  function init(root) { $$('[data-collection]', root || document).forEach(initWrap); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
